import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/profile/inventory';

const HomeRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/Account')),
    name: 'Account',
};

export default HomeRoute;
